import { RouteParam } from "../../../routes";
import { ACTION, MODULE } from "../../../utils/enums";
import { urls } from "../../../utils/urls";
import PurchaseVoucherServiceListScreen from "../purchase/purchase_service_voucher_list";
import PurchaseVoucherListScreen from "../purchase/purchase_voucher_list";
import PurchaseVoucher from "../vouchers/purchase/inward_create_screen";
import PurchaseVoucherDetail from "../vouchers/purchase/inward_detail_screen";
import ServiceVoucher from "../vouchers/purchase/service_create_screen";
import ServiceDetailVoucher from "../vouchers/purchase/service_detail_screen";
import ServiceReceiptPage from "../vouchers/purchase/service_po_list_screen";

const purchase_voucher_routes: RouteParam[] = [
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.purchase_voucher,
    component: PurchaseVoucherListScreen,
    module: MODULE.voucher,
    main_module: MODULE.procurement_panel,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },

  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.purchase_voucher + "/create",
    component: PurchaseVoucher,
    module: MODULE.voucher,
    main_module: MODULE.procurement_panel,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },
    {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.purchase_service_voucher + "/",
    component: ServiceReceiptPage,
    module: MODULE.voucher,
    main_module: MODULE.procurement_panel,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.purchase_service_voucher + "/create",
    component: ServiceVoucher,
    module: MODULE.voucher,
    main_module: MODULE.procurement_panel,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },

  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.purchase_service_voucher+"/get-srn",
    component: PurchaseVoucherServiceListScreen,
    module: MODULE.voucher,
    main_module: MODULE.procurement_panel,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },
  {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.purchase_voucher + "/detail-screen/:id",
    component: PurchaseVoucherDetail,
    module: MODULE.voucher,
    main_module: MODULE.procurement_panel,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },
   {
    isPrivate: true,
    fullScreen: false,
    exact: true,
    path: urls.purchase_service_voucher + "/detail-screen/:id",
    component: ServiceDetailVoucher,
    module: MODULE.voucher,
    main_module: MODULE.procurement_panel,
    action: [ACTION.CREATE, ACTION.READ, ACTION.UPDATE],
    operator: "or",
  },
];

export default purchase_voucher_routes;
